import FormBasicInput from "../fluxo-nsimilar/formBasic/formBasicInput";
import ContainerErrorSmall from "../error/containerError";
import IconAlert from "../../assets/svgs/icon-alert.svg";

interface ModalInputMotivoProps {
  inputMotivo?: boolean;
  titleLabel?: string;
  value?: string;
  setValue?: (text: string) => void;
  errorMessage?: string;
  marginTop?: number;
  width?: string;
}

export const ModalInputMotivo = ({
  inputMotivo,
  titleLabel,
  value,
  setValue,
  errorMessage,
  marginTop = 15,
  width = "44ch",
}: ModalInputMotivoProps) => {
  if (!inputMotivo) return null;

  return (
    <div>
      <div style={{ marginTop }}>
        <div style={{ paddingBottom: "25px" }}>
          <FormBasicInput
            title=""
            label={titleLabel}
            value={value}
            setValue={setValue}
            width={width}
            maxLength={500}
          />
          {errorMessage && (
            <ContainerErrorSmall
              id="material-part-desc-error containerErroSmall"
              label={errorMessage}
              icon={IconAlert}
              backgroudError={"#D1E4FF"}
              widthError=""
              colorError={"#000000"}
            />
          )}
        </div>
      </div>
    </div>
  );
};
